export const isValidImageSrc = (src: string) => {
  try {
    new URL(src.replace(/^\/\//, 'https://'));
    return true;
  } catch (error) {
    return false;
  }
};
